import React from "react";
import AdminCrud from "./AdminCrud";

export default function AdminBanners() {
    return (
        <AdminCrud title="Bannere" endpoint="/admin/banners" idField="banner_id" testPrefix="banners"
                   columns={[
                       { key: "image", label: "Img", type: "image" },
                       { key: "title", label: "Titlu" },
                       { key: "order", label: "Ordine" },
                       { key: "active", label: "Activ", type: "boolean" },
                   ]}
                   fields={[
                       { key: "title", label: "Titlu", required: true },
                       { key: "subtitle", label: "Subtitlu" },
                       { key: "image", label: "Imagine", type: "image", colSpan: 2, required: true },
                       { key: "link", label: "Link buton principal" },
                       { key: "cta_text", label: "Text buton principal" },
                       { key: "show_install_cta", label: "Afișează buton \"Programează instalare\"", type: "boolean" },
                       { key: "install_cta_text", label: "Text buton instalare" },
                       { key: "install_cta_link", label: "Link buton instalare" },
                       { key: "order", label: "Ordine", type: "number" },
                       { key: "active", label: "Activ", type: "boolean" },
                   ]}
                   defaultItem={{ order: 0, active: true, cta_text: "Vezi oferta", show_install_cta: false, install_cta_text: "Programează instalare", install_cta_link: "/programare-instalare" }} />
    );
}
